import styled from "@emotion/styled";
import { colors, colorsRGB } from "styles/colors";
import { fonts } from "styles/fonts";

export const ModalWrap = styled.div`
  position: relative;
  min-height: 100%;
  display: flex;
  align-items: center;
  background-color: rgba(${colorsRGB.GREY_DARK}, 0.7);
`;

export const ModalContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1000;
  top: 0;
`;

export const BackTxt = styled.div`
  margin-left: 5px;
  font-family: ${fonts.latoRegular};
  font-size: 16px;
  cursor: pointer;
`;

export const Back = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  .icon {
    transform: rotate(180deg) translateX(5px);
  }
`;

export const Navigation = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 5px 20px;
  color: ${colors.GREY_SEMIDARK};

  .icon {
    width: 20px;
    height: 20px;
    stroke: ${colors.GREY_SEMIDARK};
    fill: ${colors.GREY_SEMIDARK};
    cursor: pointer;
  }
`;

export const Title = styled.div`
  color: ${colors.GREY_DARK};
  font-family: ${fonts.abhayaBold};
  font-size: 24px;
  padding: 0px 20px;
`;

export const NoImage = styled.div`
  width: 70px;
  height: 70px;
  background-color: ${colors.GREY_LIGHT};
  color: ${colors.GREY_DARK};
  border-radius: 5px;
  .icon-recipes_2 {
    height: 70px;
    width: 70px;
    stroke: ${colors.GREY};
    fill: ${colors.GREY};
  }
`;

export const CollectionImage = styled.div`
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  img {
    width: 70px;
    height: 70px;
    border-radius: 5px;
    object-fit: cover;
    object-position: center center;
  }
`;

export const ItemTitle = styled.div`
  font-size: 16px;
  font-family: ${fonts.latoBold};
  color: ${colors.GREY_DARK};
  word-break: break-word;
  margin-bottom: 10px;
  cursor: pointer;
  @media (min-width: 769px) {
    margin-right: 5px;
    margin-bottom: 0px;
  }
`;

export const ItemRight = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media (min-width: 769px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const CollectionItemWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 20px;
  border-top: 1px solid ${colors.GREY_SEMILIGHT};
`;

export const Hint = styled.h2`
  padding: 0 20px;
  margin-bottom: 5px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  color: ${colors.GREY_SEMIDARK};
  @media (min-width: 769px) {
    margin-bottom: 15px;
  }
`;

export const ModalContent = styled.div`
  position: relative;
  max-width: 600px;
  width: 100%;
  padding: 0px;
  background-color: ${colors.WHITE};
  border-radius: 20px;
  margin: 30px auto;
`;

export const ListWrap = styled.div`
  ${CollectionItemWrap}:first-of-type {
    border: none;
  }
`;
